<script setup lang="ts">
  import {
    FormFieldContainer,
    InputField,
    LIMIT_MODE,
    DropDown,
    SwitchButton,
    type LimitMode,
    type NumberElement,
  } from '@logistiek-zonder-papier/lzp-library'
  import FlowPathInput from '@/components/form/FlowPathInput.vue'

  const field = defineModel<NumberElement>({ required: true })
</script>

<template>
  <div class="field-config-container">
    <FormFieldContainer label="Label">
      <FlowPathInput
        placeholder="e.g. ${customer.name}"
        hint="Field label. Supports ${...} interpolation."
        v-model="field.label"
        :optional="true"
        type="text"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Placeholder">
      <FlowPathInput
        placeholder="Placeholder text"
        hint="Grey hint inside the field. Supports ${...} interpolation."
        v-model="field.placeholder"
        :optional="true"
        type="text"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Default value">
      <FlowPathInput
        placeholder="Initial value"
        v-model="field.defaultValue"
        :optional="true"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Store Location">
      <InputField
        placeholder="x.path.to.location"
        hint="Target path url."
        v-model="field.storeLocation"
        type="text"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Required">
      <SwitchButton v-model="field.required" size="sm" />
    </FormFieldContainer>

    <FormFieldContainer label="Description">
      <FlowPathInput
        placeholder="Helpful text under the field"
        v-model="field.description"
        :optional="true"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Error message">
      <FlowPathInput
        placeholder="Error message under the field"
        v-model="field.error"
        :optional="true"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <DropDown
      :required="true"
      label="Limit Mode"
      :modelValue="{ value: field.limitMode }"
      idKey="value"
      :data="
        LIMIT_MODE.map(value => ({
          value,
        }))
      "
      @update:modelValue="(value: { value: LimitMode }) => (field.limitMode = value.value)"
    >
      <template #item="{ item }">{{ item.value ?? 'Selecteer een optie' }}</template>
    </DropDown>

    <template v-if="field.limitMode !== 'OFF'">
      <FormFieldContainer label="Min">
        <FlowPathInput
          placeholder="0-100"
          v-model="field.min"
          :optional="true"
          :validate-paths="true"
        />
      </FormFieldContainer>
      <FormFieldContainer label="Max">
        <FlowPathInput
          placeholder="0-100"
          v-model="field.max"
          :optional="true"
          :validate-paths="true"
        />
      </FormFieldContainer>
    </template>
  </div>
</template>

<style scoped>
  .field-config-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .two-columns {
    display: flex;
    gap: 0.75rem;
  }

  .row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
</style>
